import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../types';

const ordersItems = (state: RootState) => state.orderDetailed.data.order?.items;
const signingPaymenyIds = (state: RootState) =>
  state.operationsSign.data.orderUcp.paymentItemsIds;

export const signPaymentPositionsList = createSelector(
  [ordersItems, signingPaymenyIds],
  (items, ids) => items?.filter((item) => ids?.indexOf(item.id) !== -1)
);
